package com.neurobs.react.semanticui

import com.neurobs.react.{ElementModifiers, ReactUtil}
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiListFactory {

  private def TemplateList(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("list"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  def List(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateList(children)(uiElementModifiers)
  }

  private def TemplateListItem(handleClick: () => Unit, children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    div(
      className := "item " + elementModifiers.classString,
      style := elementModifiers.createStyle,
      onClick := handleClick
    )(
      children:_*
    )
  }

  def ListItem(handleClick: () => Unit)(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateListItem(handleClick, children)(elementModifiers)
  }

  private def TemplateListContent(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "content " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  def ListContent(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateListContent(children)(elementModifiers)
  }

  def TemplateListHeader(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "header " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }
  def ListHeader(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateListHeader(children)(elementModifiers)
  }



}
